// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___CImi","textarea":"styles_textarea__3eo9l"};